import { Box } from '@mui/material';
import type { Header } from '@tanstack/react-table';
import { filterInputBaseStyle } from './filterInputStyles';
import { filterCellBoxSx, filterNativeInputStyle } from './filterLayoutStyles';

type BooleanFilterInputProps<T> = {
  header: Header<T, unknown>;
  filterValue: string;
};

/**
 * Boolean filter input component
 * Displays a dropdown with All/True/False options
 */
const BooleanFilterInputComponent = <T,>({ header, filterValue }: BooleanFilterInputProps<T>) => {
  'use memo';
  return (
    <Box sx={filterCellBoxSx}>
      <select
        className="grid-filter-input"
        value={filterValue}
        onChange={(e) => {
          header.column.setFilterValue(e.target.value || undefined);
        }}
        style={{
          ...filterInputBaseStyle,
          ...filterNativeInputStyle,
          height: 'auto',
        }}
      >
        <option value="">All</option>
        <option value="1">True</option>
        <option value="0">False</option>
      </select>
    </Box>
  );
};

export const BooleanFilterInput = BooleanFilterInputComponent;
